export enum PlanNameEnum {
  STARTER = 'Starter',
  STARTUP = 'Startup',
  BUSINESS = 'Business',
}
